import React from "react";
import AdsSection from "../components/Ads/AdsSection";

const Ads = () => {
    return <AdsSection />;
};

export default Ads;
